export const CORNER_THICKNESS = 0.5;
export const CORNER_WIDTH = 2.5;

// flat (straight) corner trim is a single 3" strip split into two 1.5" halves
export const FLAT_TRIM_WIDTH = 3;
export const FLAT_TRIM_HALF_WIDTH = 1.5;

export const SURROUND_TEXTURE_DIMENSION = 36;

export type SurroundMaterialRoleThickness = {
	front: number;
	back: number;
	left: number;
	right: number;
};

export const SURROUND_MATERIAL_THICKNESS: Record<string, number | SurroundMaterialRoleThickness> = {
	brick: 1.25,
	concrete: 0.75,
	shiplap: 0.75,
	stone: { front: 1.5, back: 1, left: 1, right: 1 },
	wood: 0.75,
	modernStone: 1.25,
	slat: 1,
	mok: 0.75,
	scratchcoat: 0.75
};

export const CORNER_SIDE_WIDTH_BY_MATERIAL: Record<string, number> = {
	brick: 25.5,
	concrete: 26.5,
	shiplap: 26.5,
	stone: 25.5,
	wood: 26.5,
	modernStone: 25.5,
	slat: 26,
	mok: 27,
	scratchcoat: 26.5
};

export const OVERHANG_REMOVAL_BY_MATERIAL = {
	brick: 0.75,
	concrete: 0.75,
	shiplap: 0.75,
	stone: 0.75,
	wood: 0.75,
	modernStone: 0.75,
	slat: 0.5,
	mok: 0,
	scratchcoat: 0.75
};

// Slat butts with a thinner corner trim than the other base finishes, so it needs less
// inter-island padding than the standard 1"; everything else keeps the standard default.
export const STANDARD_ISLAND_PADDING = 1;
export const PADDING_BY_MATERIAL: Record<string, number> = {
	slat: 0.5
};

export const MOK_SURROUND_PREFIX = 'moks/';

export type MOKIslandDimensions = {
	height: number;
	depth: number;
};

export const MOK_ISLAND_DIMENSIONS_BY_TYPE: Record<string, MOKIslandDimensions> = {
	Grill: { height: 36, depth: 28.5 },
	Bar: { height: 40, depth: 21.25 }
};

export const MOK_COUNTERTOP_MAX_DEPTH = 30;
